import React, { useState } from "react";

import { SettingsContext } from "../settingContext";

import "../categories/Categories.css"

import {
  AllCategories,
  CropProductionInformation,
  FarmManagement,
  FertilizerRecommendation,
  Identification,
  InputsFinance,
  KnowledgeDelivery,
  MarketInfoAccess,
  Pesticides,
  Scouting,
} from "../svg";

const IconList = {
  AllCategories: AllCategories,
  CropProductionInformation: CropProductionInformation,
  FarmManagement: FarmManagement,
  FertilizerRecommendation: FertilizerRecommendation,
  Identification: Identification,
  InputsFinance: InputsFinance,
  KnowledgeDelivery: KnowledgeDelivery,
  MarketInfoAccess: MarketInfoAccess,
  Pesticides: Pesticides,
  Scouting: Scouting,
};

function Categories() {
  const settings = React.useContext(SettingsContext);

  const categoryList = [
    {
      id: "619658ef408c9bfa737f8e9f",
      name: "Knowledge delivery",
      value: "Knowledge delivery",
      icon: "KnowledgeDelivery",
    },
    {
      id: "61965bcf408c9bfa737f8ea5",
      name: "Crop production information",
      value: "Crop production information",
      icon: "CropProductionInformation",
    },
    {
      id: "61965bbb408c9bfa737f8ea3",
      name: "Pesticides",
      value: "Pesticides",
      icon: "Pesticides",
    },
    {
      id: "61965c17408c9bfa737f8ead",
      name: "Identification",
      value: "Identification",
      icon: "Identification",
    },
    {
      id: "61965c27408c9bfa737f8eaf",
      name: "Scouting",
      value: "Scouting",
      icon: "Scouting",
    },
    {
      id: "61965be0408c9bfa737f8ea7",
      name: "Farm management",
      value: "Farm management",
      icon: "FarmManagement",
    },
    {
      id: "61965bf3408c9bfa737f8ea9",
      name: "Fertilizer recommendation",
      value: "Fertilizer recommendation",
      icon: "FertilizerRecommendation",
    },
    {
      id: "61965ba5408c9bfa737f8ea1",
      name: "Market info & Access",
      value: "Market info & Access",
      icon: "MarketInfoAccess",
    },
    {
      id: "61965c05408c9bfa737f8eab",
      name: "Inputs & finance",
      value: "Inputs & finance",
      icon: "InputsFinance",
    },
  ];

  var allCategory = {
    id: "619658ef408c9bfa737",
    name: "All Categories",
    value: "",
    icon: "AllCategories",
  };

  const categoryToDisplay = categoryList.slice();

  categoryToDisplay.push(allCategory);

  categoryToDisplay.forEach((element) => {
    element.selected = false;
  });

  const [appState, setAppState] = useState(categoryToDisplay);

  const categorySelected = function (id) {
    var categories = [...appState];

    var category = categories.filter((s) => {
      return s.id === id;
    });

    if (id === allCategory.id) {
      if (!category[0].selected) {
        category[0].selected = !category[0].selected;
        categories.forEach((element) => {
          if (element.id !== allCategory.id) {
            element.selected = false;
          }
        });
      }
    } else {
      category[0].selected = !category[0].selected;

      var allcategory = categories.filter((s) => {
        return s.id === allCategory.id;
      });

      allcategory[0].selected = false;
    }

    setAppState(categories);
  };

  return (
    <form method="GET" action={settings.post_url}>
      <div className="row row-cols-2 row-cols-md-5 noselect display-flex">
        {appState.map((category, idx) => {
          return (
            <div className="col" key={idx}>
              <div
                className={category.selected ? "cat-item active" : "cat-item"}
                onClick={(e) => {
                  categorySelected(category.id);
                }}
              >
                {React.createElement(IconList[category.icon])}
                <span className="title">{category.name}</span>
                <input
                    type="checkbox"
                    checked={category.selected}
                    value={category.value}
                    name="cg[]"
                    onChange={(e)=>{}}
                  />
              </div>
            </div>
          );
        })}
      </div>
      <div className="row">
        <div className="col text-center">
          <button className="button-green" type="submit">
            Search
          </button>
        </div>
      </div>
    </form>
  );
}

export default Categories;
